const { default: SignaturePad } = require("signature_pad");

/* eslint-disable no-undef */
(function(global, factory) {
    if (typeof exports === "object" && typeof module !== "undefined") {
        module.exports = factory();
    } else if (typeof define === "function" && define.amd) {
        define(factory);
    } else {
        (global || window).SignaturePad = factory();
    }
}(this, function() {
    "use strict";

    // eslint-disable-next-line no-unused-vars
    function Point(x, y, time) {
        this.x = x;
        this.y = y;
        this.time = time || Date.now();
    }

    // eslint-disable-next-line no-unused-vars
    function Bezier(startPoint, control1, control2, endPoint) {
        this.startPoint = startPoint;
        this.control1 = control1;
        this.control2 = control2;
        this.endPoint = endPoint;
    }

    function throttle(func, wait, options) {
        var context, args, result;
        var timeout = null;
        var previous = 0;
        if (!options) options = {};
        var later = function() {
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        };
        return function() {
            var now = Date.now();
            if (!previous && options.leading === false) previous = now;
            var remaining = wait - (now - previous);
            context = this;
            args = arguments;
            if (remaining <= 0 || remaining > wait) {
                if (timeout) {
                    clearTimeout(timeout);
                    timeout = null;
                }
                previous = now;
                result = func.apply(context, args);
                if (!timeout) context = args = null;
            } else if (!timeout && options.trailing !== false) {
                timeout = setTimeout(later, remaining);
            }
            return result;
        };
    }

    function SignaturePad(canvas, options) {
        var self = this;
        var opts = options || {};

        this.velocityFilterWeight = opts.velocityFilterWeight || 0.7;
        this.minWidth = opts.minWidth || 0.5;
        this.maxWidth = opts.maxWidth || 2.5;
        this.throttle = 'throttle' in opts ? opts.throttle : 16;
        this.minDistance = 'minDistance' in opts ? opts.minDistance : 5;

        if (this.throttle) {
            this._strokeMoveUpdate = throttle(SignaturePad.prototype._strokeUpdate, this.throttle);
        } else {
            this._strokeMoveUpdate = SignaturePad.prototype._strokeUpdate;
        }

        this.dotSize = opts.dotSize || function() {
            return (this.minWidth + this.maxWidth) / 2;
        };

        this.penColor = opts.penColor || 'black';
        this.backgroundColor = opts.backgroundColor || 'rgba(0,0,0,0)';
        this.onBegin = opts.onBegin;
        this.onEnd = opts.onEnd;

        this._canvas = canvas;
        this._ctx = canvas.getContext('2d');
        this.clear();

        this._handleMouseDown = function(event) {
            if (event.which === 1) {
                self._mouseButtonDown = true;
                self._strokeBegin(event);
            }
        };

        this._handleMouseMove = function(event) {
            if (self._mouseButtonDown) {
                self._strokeMoveUpdate(event);
            }
        };

        this._handleMouseUp = function(event) {
            if (event.which === 1 && self._mouseButtonDown) {
                self._mouseButtonDown = false;
                self._strokeEnd(event);
            }
        };

        this._handleTouchStart = function(event) {
            if (event.targetTouches.length === 1) {
                var touch = event.changedTouches[0];
                self._strokeBegin(touch);
            }
        };

        this._handleTouchMove = function(event) {
            event.preventDefault();
            var touch = event.targetTouches[0];
            self._strokeMoveUpdate(touch);
        };

        this._handleTouchEnd = function(event) {
            if (event.target === self._canvas) {
                event.preventDefault();
                self._strokeEnd(event);
            }
        };

        this.on();
    }

    SignaturePad.prototype.clear = function() {
        var ctx = this._ctx;
        var canvas = this._canvas;
    
        ctx.fillStyle = this.backgroundColor;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        this._data = [];
        this._reset();
    };

   

    // Additional methods for SignaturePad...

    return SignaturePad;
}));

export default SignaturePad;
